import axiosConfig from "axios";

export let baseURL=process.env.REACT_APP_BASE_URL
export let shareURL = process.env.REACT_APP_SHARING_URL;

// export let baseURL = "https://services-stage.visaero.com/";

// export let shareURL = "https://nofrictionvisaapp-stage.visaero.com";

let axios = axiosConfig.create({
  baseURL: baseURL,
  // headers: { Authorization: "Bearer " + localStorage.getItem("session_id") },
});

export const axiosNoSession = axiosConfig.create({
  baseURL: baseURL,
});

export default axios;
